<app-navbar [title]="'PRODUCT_LIST.PAGE_TITLE' | translate" [backLink]="'/'" [showBackButton]="true" [showLogout]="true">
</app-navbar>

<div class="body">
  <!-- Mobile: Dropdown filter (shown only on small screens) -->
  <div class="mobile-filter-dropdown">
    <mat-form-field appearance="outline" class="form-field-full-width">
      <mat-label>{{ 'PRODUCT_LIST.SELECT_PRODUCT' | translate }}</mat-label>
      <mat-select [value]="activeTab" (selectionChange)="setTab($event.value)">
        <mat-option [value]="''">
          {{ 'PRODUCT_LIST.ALL' | translate }}
        </mat-option>
        <mat-option *ngFor="let product of products" [value]="product.productId">
          {{ product.nameLa }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>

  <!-- Desktop: Horizontal tabs (hidden on mobile) -->
  <div class="tab-buttons button-scroll desktop-tabs">
    <button class="tab-buttons" [class.active]="activeTab === ''" (click)="setTab('')">
      {{ 'PRODUCT_LIST.ALL' | translate }}
    </button>
    <button
      *ngFor="let product of products"
      class="tab-buttons"
      [class.active]="activeTab === product.productId"
      (click)="setTab(product.productId)"
    >
      {{ product.nameLa }}
    </button>
  </div>

  @if (loading) {
  <div class="text-center py-5 loading-container">
    <mat-spinner diameter="50"></mat-spinner>
    <p class="la-font mt-3">{{ 'PRODUCT_LIST.LOADING_DATA' | translate }}</p>
  </div>
  }

  <div class="box">
    <ng-container *ngFor="let item of productsAllPlan; let i = index">
      <div
        *ngIf="activeTab ? activeTab === item.productId : !activeTab"
        class="any"
        routerLink="/I4UProductPlanDetail/{{ item.productId }}/{{ item.planId }}"
        role="link"
        [attr.aria-label]="item.planName"
      >
        <div class="img borderP img-centered">
          <img 
            src="{{ item.planBannerUrl }}" 
            alt="{{ item.planName }}" 
            loading="lazy"
          />
        </div>
        <div class="content">
          <h3 class="product-title">{{ item.planName }}</h3>
          
          <div class="product-section">
            <h6 class="section-label">{{ 'PRODUCT_LIST.BENEFITS' | translate }}</h6>
            <h5>
              @if(item.minCoverageAmt == item.maxCoverageAmt){
              {{ item.minCoverageAmt | number }}
              }@else{ @if(item.minCoverageAmt > 0){

              {{ item.minCoverageAmt | number }} - }@else{ {{ 'PRODUCT_LIST.MAXIMUM' | translate }} }
              {{ item.maxCoverageAmt | number }}
              }
            </h5>
          </div>
          
          <div class="product-section">
            <h6 class="section-label">{{ 'PRODUCT_LIST.COVERAGE_PERIOD' | translate }}</h6>
            @if(item?.coverageYear > 0){
            <h5>{{ item?.coverageYear }}</h5>
            }@else if(!item?.coverageYear){
            <h5>{{ 'PRODUCT_LIST.LIFETIME' | translate }}</h5>
            }@else { ----- }
          </div>
          
          <div class="product-section">
            <h6 class="section-label">{{ 'PRODUCT_LIST.SUITABLE_FOR' | translate }}</h6>
            <h5>{{ item.bestFor }}</h5>
          </div>
        </div>

        <div class="borderP bottom">
          <img src="../../../assets/images/kip.png" alt="" />
          <div>
            <div>
              <h1>
                {{ item.premiumPerYear | number }}
              </h1>
            </div>
          </div>
          <span> {{ 'PRODUCT_LIST.PREMIUM_PER_YEAR' | translate }} </span>
        </div>
      </div>
    </ng-container>
  </div>
</div>
